import React from "react";
import styled from "styled-components/macro";
import { Side } from "../SideMenu/side";

const SaveButton = styled.div<SaveButtonProps>`
    position: absolute;
    left: ${({ side }) => (side === Side.Right ? 0 : "auto")};
    right: ${({ side }) => (side === Side.Left ? 0 : "auto")};
    top: 100px;
    width: 118px;
    cursor: pointer;
    height: 32px;
    pointer-events: auto;
    font-size: ${({ theme }) => theme.paragraph.fontSize};
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 4px;
    margin: 0 30px;
    border: 1px solid ${({ theme }) => theme.buttonBack.backgroundColor};
    color: ${({ theme }) => theme.buttonBack.backgroundColor};
    background: rgba(255, 255, 255, 0.3);
    &:hover {
        background: rgba(255, 255, 255, 0.4);
    }
    z-index: 2;
`;

interface SaveButtonProps {
    side: Side;
}

export const SaveImageButton = ({ side, onClick }: { side: Side; onClick: (event: any) => void }) => {
    return (
        <SaveButton side={side} onClick={onClick}>
            <p>Save image</p>
        </SaveButton>
    );
};
